import { apiClient } from '@/api/client'
import type {
  OARankingDimension,
  OARankingMetric,
  OARankingPeriod,
  OARankingResponse,
} from '@/types/oa-ranking'

export const oaRankingApi = {
  getRanking: async (
    metric: OARankingMetric,
    dimension: OARankingDimension,
    period: OARankingPeriod,
  ): Promise<OARankingResponse> => {
    const url = `/dashboard/oa-rankings?metric=${encodeURIComponent(metric)}&dimension=${encodeURIComponent(dimension)}&period=${encodeURIComponent(period)}`
    const res = await apiClient.get<OARankingResponse>(url)
    return res.data
  },
}
